import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Aircraft } from '@shared/models/activity-summary/aircraft';
import { TimeSchedule } from '@shared/models/activity-summary/time-schedule';
import { FormatMinutes, FormatTimePipe } from '@shared/pipes/format-time.pipe';
import { designateTagType } from '@shared/utilities/utilities';
import { AppService } from 'app/app.service';
import { DateTime } from 'luxon';
import { FlightsService } from '../services/flight.service';

@Component({
    selector: 'app-flight-item',
    imports: [
        CommonModule,
        FormatMinutes,
        FormatTimePipe
    ],
    templateUrl: './flight-item.component.html',
    styleUrl: './flight-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlightItemComponent implements OnInit {

  @Input() isTimeFormatUTC?: boolean | null;
  @Input() flightNumber?: number | null;
  @Input() aircraft?: Aircraft | null;
  @Input() depStation?: string | null;
  @Input() arrStation?: string | null;
  @Input() depTimes?: TimeSchedule;
  @Input() arrTimes?: TimeSchedule; 
  @Input() flightTimeActual?: string | null;
  @Input() flightTimeScheduled?: string | null;
  @Input() isDeadhead?: boolean | null;
  @Input() isCancelled?: boolean | null;

  tag: string = "---" 

  airplaneActiveLight = "/assets/icons/aircraft/activeLight.svg";
  airplaneActiveDark = "/assets/icons/aircraft/activeDark.svg";
  airplaneCancelLight = "/assets/icons/aircraft/cancelLight.svg"; 
  airplaneCancelDark = "/assets/icons/aircraft/cancelDark.svg";
  seatActiveLight = "/assets/icons/seat/seatActiveLight.svg";
  seatActiveDark = "/assets/icons/seat/seatActiveDark.svg";
  seatCancelLight = "/assets/icons/seat/seatCancelLight.svg"; 
  seatCancelDark = "/assets/icons/seat/seatCancelDark.svg";

  constructor(
    public appService: AppService,
    private flightService: FlightsService
  ) {}
  
  ngOnInit(): void {
    this.tag = designateTagType(this.isDeadhead || false, this.isCancelled || false);
  }


  convertDatetoDay(date?: string): string | undefined {
    if (date) {
      const dateTime = DateTime.fromISO(date, { zone: 'utc' });
      return dateTime.toFormat('dd');
    }
    return undefined;
  }

  convertDateToMonth(date?: string): string | undefined {
    if (date) {
      const dateTime = DateTime.fromISO(date, { zone: 'utc' });
      return dateTime.toFormat('MMM');
    }
    return undefined;
  }

  convertDateToYear(date?: string): string | undefined {
    if (date) {
      const dateTime = DateTime.fromISO(date, { zone: 'utc' });
      return dateTime.toFormat('yyyy');
    }
    return undefined;
  }

  validateAircraftId(aircraftId?: string): string {
    return this.flightService.validateAircraft(aircraftId);
  }
}
